const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  baseUrl: import.meta.env.VITE_BASE_URL,
  nxmapBaseUrl: import.meta.env.VITE_NXMAP_URL,
  nxplanBaseUrl: import.meta.env.VITE_NXPLAN_URL,
  isStaging: import.meta.env.MODE === "staging",
};

export default config;
